//jsxhook

import { AxiosResponse } from "axios"
import React from "react"

import { useAxiosClient } from "../AxiosClient"
import { paymentApiUrl } from "../Config"
import { useRootSelector } from "../State"

export interface BorgunPaymentApi {
  pay: (cartId: string) => Promise<AxiosResponse<unknown>>
}

export const useBorgunPaymentApi = (): BorgunPaymentApi => {
  const cardToken = useRootSelector(it => it.borgunState.paymentToken)
  const axios = useAxiosClient()

  const path = paymentApiUrl("/borgun/pay")

  return {
    pay: (
      cartId: string
    ): Promise<
      AxiosResponse<
        { cartId: string } | { upstreamStatus: number; message: string }
      >
    > => {
      return axios.post(path, {
        cardToken,
        cartId
      })
    }
  }
}
